import React from "react";
import useAxiosPrivate from "./useAxiosPrivate";
import { useDispatch } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
const useAddLaabhPartner = (form) => {
  // console.log(form);
  const Axios = useAxiosPrivate();
  const dispatch = useDispatch();
  const addLaabhPartner = async (param) => {
    // console.log(param, "distributorList");
    const response = await Axios.post("/add_laabh_partner", param);
    const data = await response.data;
    
    // if (data.status === 200) {
    //   toast.success(data.message);
    // } else if (data.status === 400) {
    //   toast.error(data.message);
    // } 
    
    // else {
    //   toast.error("Failed to Add");
    // }


    return data;

    // console.log(data);
  };
  // useEffect(() => {
  //   getAllUserList();
  // }, []);
  return addLaabhPartner;
};

export default useAddLaabhPartner;
